import { SideNavActionsMenuColumn } from "@core/layout/components/side-nav/components/side-nav-actions-menu/models/side-nav-actions-menu.model";
import { SideNavActionsIds } from "@core/layout/components/side-nav/components/side-nav-actions-menu/enums/side-nav-actions.ids";
import { LinkUtils } from "@core/layout/utils/link.utils";
import { AngularRoutesEnum, DojoRoutesEnum, NavigationBase } from "@core/layout/enums/layout-routes.enum";

export const SIDE_NAV_ACTIONS_ITEMS: SideNavActionsMenuColumn[] = [
	{
		id: SideNavActionsIds.ORDONNANCE,
		label: "Ordonnance",
		iconColor: "menu-golden-darker",
		backgroundColor: "bg-menu-golden-lighter",
		items: [
			{
				id: SideNavActionsIds.ORDONNANCE_DE_SOIN,
				label: "Ordo de soin",
				icon: "file-medical",
				link: LinkUtils.generateLinkModel(NavigationBase.ANGULAR, [
					AngularRoutesEnum.ORDONNANCE_WEB_AY,
					AngularRoutesEnum.ORDONNANCE_CREATION_WEB_AY,
				]),
			},
			{
				id: SideNavActionsIds.ORDONNANCE_RAPIDE,
				label: "Ordo rapide",
				icon: "bolt",
				action: null,
			},
			{
				id: SideNavActionsIds.ORDONNANCE_BSI,
				label: "BSI",
				icon: "clipboard-notes",
				action: null,
			},
			{
				id: SideNavActionsIds.ORDONNANCE_PRESCRIPTION_IDEL,
				label: "Prescription IDEL",
				icon: "medkit",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.PATIENTS,
					":idPatient",
					DojoRoutesEnum.PRESCRIPTION_AUX,
					DojoRoutesEnum.ADD,
				]),
			},
			{
				id: SideNavActionsIds.ORDONNANCE_PRESCRIPTION_IPA,
				label: "Prescription IPA",
				icon: "medkit",
				link: LinkUtils.generateLinkModel(
					NavigationBase.ANGULAR,
					AngularRoutesEnum.PRESCRIPTION_MEDICAMENTEUSE,
				),
			},
			{
				id: SideNavActionsIds.ORDONNANCE_MONOGRAPHIE,
				label: "Monographie",
				icon: "book",
				action: null,
			},
		],
	},
	{
		id: SideNavActionsIds.PAIEMENT,
		label: "Paiement",
		iconColor: "menu-wisteria-darker",
		backgroundColor: "bg-menu-wisteria-lighter",
		items: [
			{
				id: SideNavActionsIds.PAIEMENT_FACTURER,
				label: "Facturer",
				icon: "euro-circle",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.FACTURATION,
					DojoRoutesEnum.FACTURER,
					DojoRoutesEnum.VISITE,
				]),
			},
			{
				id: SideNavActionsIds.PAIEMENT_TELETRANSMETTRE,
				label: "Télétransmettre",
				icon: "envelope-plane",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.TELETRANSMISSION,
					DojoRoutesEnum.TELETRANSMETTRE,
				]),
			},
			{
				id: SideNavActionsIds.PAIEMENT_SAISIR_UN_PAIEMENT,
				label: "Saisir un paiement",
				icon: "tirelire",
				link: LinkUtils.generateLinkModel(
					NavigationBase.DOJO,
					[DojoRoutesEnum.COMPTA, DojoRoutesEnum.LISTE_REGLEMENTS],
					{ action: "add" },
				),
			},
			{
				id: SideNavActionsIds.PAIEMENT_REDEVANCE,
				label: "Calculer une redevance",
				icon: "percentage",
				action: null,
			},
			{
				id: SideNavActionsIds.PAIEMENT_CHIFFRE_AFFAIRES,
				label: "Calculer mon CA",
				icon: "euros",
				action: null,
			},
		],
	},
	{
		id: SideNavActionsIds.PATIENTELE,
		label: "Patientèle",
		iconColor: "menu-green-darker",
		backgroundColor: "bg-menu-green-lighter",
		items: [
			{
				id: SideNavActionsIds.PATIENTELE_PATIENT,
				label: "Créer un patient",
				icon: "user-plus",
				action: null,
			},
			{
				id: SideNavActionsIds.PATIENTELE_RENDEZ_VOUS,
				label: "Ajouter un rendez-vous",
				icon: "calendar-alt",
				action: null,
			},
			{
				id: SideNavActionsIds.PATIENTELE_LECTURE_CV,
				label: "Lire la CV",
				icon: "cartevitale",
				action: null,
			},
		],
	},
	{
		id: SideNavActionsIds.COORDINATION,
		label: "Coordination",
		iconColor: "menu-bay-darker",
		backgroundColor: "bg-menu-bay-lighter",
		items: [
			{
				id: SideNavActionsIds.COORDINATION_CONSTANTE,
				label: "Constante",
				icon: "constantes",
				action: null,
			},
			{
				id: SideNavActionsIds.COORDINATION_TRAITEMENT,
				label: "Traitement",
				icon: "capsule",
				link: LinkUtils.generateLinkModel(
					NavigationBase.DOJO,
					[DojoRoutesEnum.PATIENTS, ":idPatient", DojoRoutesEnum.DOSSIER_SOINS_TIMELINE],
					{
						action: "addTraitement",
					},
				),
			},
			{
				id: SideNavActionsIds.COORDINATION_TRANSMISSION,
				label: "Transmission",
				icon: "comment-dots",
				link: LinkUtils.generateLinkModel(
					NavigationBase.DOJO,
					[DojoRoutesEnum.PATIENTS, ":idPatient", DojoRoutesEnum.DOSSIER_SOINS_TIMELINE],
					{
						action: "addTransmission",
					},
				),
			},
			{
				id: SideNavActionsIds.COORDINATION_DIAGRAMME_DE_SOIN,
				label: "Diagramme de soin",
				icon: "file-check",
				link: LinkUtils.generateLinkModel(
					NavigationBase.DOJO,
					[DojoRoutesEnum.PATIENTS, ":idPatient", DojoRoutesEnum.DOSSIER_SOINS_TIMELINE],
					{
						action: "addDiagramme",
					},
				),
			},
			/**
			 * Ne pas supprimer, à décommenter quand on implémentera la fonctionnalité
			 */
			// {
			// 	id: SideNavActionsIds.COORDINATION_SUIVI_DE_PLAIE,
			// 	label: "Suivi de plaie",
			// 	icon: "band-aid",
			// action: null,
			// },
		],
	},
	/**
	 * Ne pas supprimer, à décommenter quand on implémentera la fonctionnalité
	 */
	// {
	// 	id: SideNavActionsIdsEnum.TELESANTE,
	// 	label: "Télésanté",
	// 	iconColor: "menu-sand-darker",
	// 	backgroundColor: "bg-menu-sand-lighter",
	// 	items: [
	// 		{
	// 			id: SideNavActionsIdsEnum.TELESANTE_TELESOIN,
	// 			label: "Télésoin",
	// 			icon: "camera",
	// 			action: null,
	// 		},
	// 		{
	// 			id: SideNavActionsIdsEnum.TELESANTE_TELEEXPERTISE,
	// 			label: "Téléexpertise",
	// 			icon: "comment-alt-lines",
	// 			action: null,
	// 		},
	// 		{
	// 			id: SideNavActionsIdsEnum.TELESANTE_TELECONSULTATION,
	// 			label: "Téléconsultation",
	// 			icon: "constantes",
	//			action: null,
	// 		},
	// 	],
	// },
];
